import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaginatedResponse } from 'models/common/paginated-response.interface';
import { Customer } from 'models/customers/customer.class';

interface CustomersState {
  all: PaginatedResponse<Customer> | null;
  selected: Customer | null;
  loading: boolean;
}

export const initialState: CustomersState = {
  all: null,
  selected: null,
  loading: false,
};

export const slice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    fetchCustomerSuccess: (state, action: PayloadAction<Customer>) => {
      state.selected = action.payload;
      state.loading = false;
    },
    saveCustomerStart: state => {
      state.loading = true;
    },
    saveCustomerSuccess: (state, action: PayloadAction<Customer>) => {
      state.selected = action.payload;
      state.loading = false;
    },
    saveCustomerError: state => {
      state.loading = false;
    },
    resetCustomersState: state => {
      state.loading = false;
      state.selected = null;
    },
  },
});

export const {
  fetchCustomerSuccess,
  resetCustomersState,
  saveCustomerStart,
  saveCustomerSuccess,
  saveCustomerError,
} = slice.actions;

export default slice.reducer;
